module.exports = __webpack_public_path__ + "img/img-4.1384ad50.png";